import { Model } from 'pinia-orm'

import { Attr, BelongsTo, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { Equipment } from 'modules/Equipment/Equipment'
import { Tenant } from 'modules/Tenant/Tenant'

export class MileageUnitOfMeasure extends Model {
  static override entity = 'mileage_unit_of_measures'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare unit_of_measure: string
  @Attr(null) declare label: string

  @HasMany(() => Equipment, 'equipment_id') declare equipments: Equipment[]

  @Attr(null) declare tenant_id: string
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
}
